import React, { useEffect, useState } from "react"

import PropTypes from "prop-types"

import "./index.less"
import { Input, Table } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import ModalCustom from "../../ModalCustom"

const SegmentsModal = (props) => {
  const [searchedSegments, setSearchedSegments] = useState([])
  const [searchText, setSearchText] = useState("")

  const GROUPS_TABLE_COLUMNS = [
    {
      title: `Segmentos (${props.segments ? props.segments.length : 0})`,
      dataIndex: "name_segment",
      render: (text, record) => {
        return record.name_segment || record.name
      },
      sorter: (a, b) => {
        if (a.name_segment) {
          return a.name_segment.localeCompare(b.name_segment)
        }
        return a.name.localeCompare(b.name)
      },
    },
  ]

  useEffect(() => {
    setSearchedSegments(props.segments)
  }, [props.segments])

  const onChangeSearch = (event) => {
    if (event.target.value.trim().length) {
      const copy = [...props.segments]
      const search = copy.filter((value) =>
        value.name_segment
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      setSearchText(event.target.value)
      setSearchedSegments(search)
    } else {
      setSearchText(event.target.value)
      setSearchedSegments(props.segments)
    }
  }

  return (
    <ModalCustom
      modalOpen={props.show}
      showOnlyAccept
      showFooter={false}
      title={`Segmentos de ${props.collaboratorName}`}
      onOk={() => props.onOk()}
      onCancel={() => props.onOk()}>
      <Input
        style={{ width: "70%" }}
        placeholder="Buscar..."
        value={searchText}
        onChange={onChangeSearch}
        suffix={<SearchOutlined style={{ color: "#A7A3A3" }} />}
      />
      <Table
        className="table-groups"
        columns={GROUPS_TABLE_COLUMNS}
        scroll={{ y: 312 }}
        pagination={false}
        dataSource={searchedSegments}
      />
    </ModalCustom>
  )
}

SegmentsModal.propTypes = {
  segments: PropTypes.array,
  collaboratorName: PropTypes.string,
  show: PropTypes.bool,
  onOk: PropTypes.func,
}

export default SegmentsModal
